import { PortfolioThunkGenerator } from 'utility/redux/thunkGenerator';
import { globalFilterSelector } from '../../../../../utility/redux/globalFilter.selector';

const generatedHttpThunk = new PortfolioThunkGenerator('trialsSummary');
generatedHttpThunk.resource = `portfolio-health/trials-summary`;
generatedHttpThunk.globalFilterSelector = globalFilterSelector;

export default generatedHttpThunk.generateThunk();
